import { store } from "../store";

export const enableLayoutChanged = () => {
  store.layoutChanged = true;
};

export const disableLayoutChanged = () => {
  store.layoutChanged = false;
};
